var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.invoiceModalData.open
        ? _c("sideBarInvoiceModalModal", {
            attrs: {
              modalData: _vm.invoiceModalData,
              onModalClose: _vm.closeModal,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.exportModalData
        ? _c(
            "EmptyCardModal",
            {
              ref: "modalExportComponent",
              attrs: {
                modalData: _vm.exportModalData,
                onModalClose: () => (_vm.exportModalData = null),
                onModalAccept: () => _vm.exportStore(),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c(
                        "ExcelExportOptions",
                        { ref: "exportExcelOptions" },
                        [
                          _vm._t("default", function () {
                            return [
                              _vm.$currentRole === "admin"
                                ? _c(
                                    "div",
                                    { staticClass: "form-group mb-0" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.exportDetails.details,
                                              expression:
                                                "exportDetails.details",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.exportDetails.details
                                            )
                                              ? _vm._i(
                                                  _vm.exportDetails.details,
                                                  null
                                                ) > -1
                                              : _vm.exportDetails.details,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.exportDetails.details,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.exportDetails,
                                                      "details",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.exportDetails,
                                                      "details",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.exportDetails,
                                                  "details",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                экспортировать детали препарата\n              "
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group mb-0" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.exportDetails.store_zero,
                                        expression: "exportDetails.store_zero",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.exportDetails.store_zero
                                      )
                                        ? _vm._i(
                                            _vm.exportDetails.store_zero,
                                            null
                                          ) > -1
                                        : _vm.exportDetails.store_zero,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.exportDetails.store_zero,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.exportDetails,
                                                "store_zero",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.exportDetails,
                                                "store_zero",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.exportDetails,
                                            "store_zero",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                выгружать с остатком 0\n              "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-group mb-0" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.exportDetails
                                            .store_remain_comparing,
                                        expression:
                                          "exportDetails.store_remain_comparing",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.exportDetails.store_remain_comparing
                                      )
                                        ? _vm._i(
                                            _vm.exportDetails
                                              .store_remain_comparing,
                                            null
                                          ) > -1
                                        : _vm.exportDetails
                                            .store_remain_comparing,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.exportDetails
                                              .store_remain_comparing,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.exportDetails,
                                                "store_remain_comparing",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.exportDetails,
                                                "store_remain_comparing",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.exportDetails,
                                            "store_remain_comparing",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                сравнивать со складом МСК-дор\n              "
                                  ),
                                ]),
                              ]),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            [_c("Breadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "flex justify-content-between" }, [
                _c("div", [
                  _c("div", { staticClass: "form-group mb-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reduceStore,
                          expression: "reduceStore",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ch_1" },
                      domProps: {
                        checked: Array.isArray(_vm.reduceStore)
                          ? _vm._i(_vm.reduceStore, null) > -1
                          : _vm.reduceStore,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.reduceStore,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.reduceStore = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.reduceStore = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.reduceStore = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pl-2 pointer", attrs: { for: "ch_1" } },
                      [
                        _vm._v(
                          "вычитать со склада препараты на руках у курьеров"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reduceType,
                          expression: "reduceType",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        id: "type_1",
                        type: "radio",
                        value: "1",
                        disabled: !_vm.reduceStore,
                      },
                      domProps: { checked: _vm._q(_vm.reduceType, "1") },
                      on: {
                        change: function ($event) {
                          _vm.reduceType = "1"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label pointer",
                        attrs: { for: "type_1" },
                      },
                      [
                        _vm._v(
                          "\n                вычитать на основе системы рюкзаков\n              "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reduceType,
                          expression: "reduceType",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        id: "type_2",
                        type: "radio",
                        value: "2",
                        disabled: !_vm.reduceStore,
                      },
                      domProps: { checked: _vm._q(_vm.reduceType, "2") },
                      on: {
                        change: function ($event) {
                          _vm.reduceType = "2"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label pointer",
                        attrs: { for: "type_2" },
                      },
                      [
                        _vm._v(
                          "\n                вычитать на основе заявок\n              "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mt-2" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Номера накладных для игнорирования поступлений"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ignoreInvoices,
                          expression: "ignoreInvoices",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        placeholder: "1111,2222,3333,....",
                        type: "text",
                      },
                      domProps: { value: _vm.ignoreInvoices },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.ignoreInvoices = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("LoadingButton", {
                      attrs: {
                        type: "button",
                        title: "Показать остатки",
                        className: "btn btn-outline-info",
                        color: _vm.$constants.LOADING_COLOR,
                        loading: _vm.loading,
                        onClick: () => {
                          this.getStoreStatus()
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              !_vm.loading
                ? _c("div", [
                    _vm.drugs && _vm.drugs.length
                      ? _c("div", { staticClass: "text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.exportStore(false)
                                },
                              },
                            },
                            [_vm._v("Экспортировать в XLS\n            ")]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoices && _vm.invoices.length
                      ? _c("div", [
                          _c("p", [
                            _vm._v(
                              "Вычитать из наличия на складе содержимое накладных:"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "table",
                            { staticClass: "table table-sm table-hover mt-1" },
                            [
                              _c(
                                "tbody",
                                [
                                  _c("tr", [
                                    _c("td", { attrs: { width: "40px" } }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectAllInvoices,
                                            expression: "selectAllInvoices",
                                          },
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectAllInvoices
                                          )
                                            ? _vm._i(
                                                _vm.selectAllInvoices,
                                                null
                                              ) > -1
                                            : _vm.selectAllInvoices,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a = _vm.selectAllInvoices,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectAllInvoices =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectAllInvoices = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectAllInvoices = $$c
                                              }
                                            },
                                            _vm.selectAll,
                                          ],
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { attrs: { colspan: "10" } }, [
                                      _vm._v("Выбрать все накладные"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.invoices, function (invoice) {
                                    return _c("tr", [
                                      _c("td", { attrs: { width: "40px" } }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.selectedInvoices[
                                                  invoice.id
                                                ],
                                              expression:
                                                "selectedInvoices[invoice.id]",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.selectedInvoices[invoice.id]
                                            )
                                              ? _vm._i(
                                                  _vm.selectedInvoices[
                                                    invoice.id
                                                  ],
                                                  null
                                                ) > -1
                                              : _vm.selectedInvoices[
                                                  invoice.id
                                                ],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.selectedInvoices[
                                                    invoice.id
                                                  ],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.selectedInvoices,
                                                      invoice.id,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.selectedInvoices,
                                                      invoice.id,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.selectedInvoices,
                                                  invoice.id,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { width: "110px" } }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-xs btn-info newWindowBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openInvoiceInModal(
                                                  invoice.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-eye",
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(invoice.id) +
                                            "\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { width: "150px" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printDate(
                                              invoice.delivery_date,
                                              "DD.MM.YYYY HH:mm"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { width: "200px" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$AllStores[invoice.store_in]
                                              .title
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(invoice.comment)),
                                      ]),
                                    ])
                                  }),
                                ],
                                2
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "table table-sm table-hover mt-1" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _vm._v(" "),
                            _c("th"),
                            _vm._v(" "),
                            _c("th", [_vm._v("Препарат")]),
                            _vm._v(" "),
                            _c("th"),
                            _vm._v(" "),
                            _c("th", [_vm._v("Кол")]),
                            _vm._v(" "),
                            _c("th", [
                              _c(
                                "span",
                                {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSorting("costPrice")
                                    },
                                  },
                                },
                                [
                                  _vm.sorting.costPrice === "asc"
                                    ? [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-sort-amount-asc",
                                        }),
                                      ]
                                    : _vm.sorting.costPrice === "desc"
                                    ? [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-sort-amount-desc",
                                        }),
                                      ]
                                    : [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-sort",
                                        }),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(
                                "\n                Себест.\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Сумма")]),
                            _vm._v(" "),
                            _c("th", [
                              _c(
                                "span",
                                {
                                  staticClass: "pointer",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSorting("dateStamp")
                                    },
                                  },
                                },
                                [
                                  _vm.sorting.dateStamp === "asc"
                                    ? [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-sort-amount-asc",
                                        }),
                                      ]
                                    : _vm.sorting.dateStamp === "desc"
                                    ? [
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-sort-amount-desc",
                                        }),
                                      ]
                                    : [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-sort",
                                        }),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(
                                "\n                Срок годн.\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Поступление")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Накладная")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _c("tr", { staticClass: "total_tr" }, [
                              _c("td", { attrs: { colspan: "4" } }, [
                                _vm._v("Итого"),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.totalData.drugs))]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.totalData.sum))]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortedDrugs, function (drug, index) {
                              return _vm.updatedStore[drug.id]
                                ? _c("tr", [
                                    _c("td", [_vm._v(_vm._s(index + 1))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.id))]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.title))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      drug.cool
                                        ? _c("i", {
                                            staticClass: "icon icon-snowflake",
                                          })
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(_vm._s(_vm.updatedStore[drug.id])),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(drug.costPrice))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          Math.round(
                                            drug.costPrice *
                                              _vm.updatedStore[drug.id] *
                                              10
                                          ) / 10
                                        ) + "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      _vm._l(drug.validDates, function (vd) {
                                        return vd.is_active
                                          ? _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.printDate(
                                                    vd.expire_date,
                                                    "DD.MM.YYYY"
                                                  )
                                                )
                                              ),
                                            ])
                                          : _vm._e()
                                      }),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.incomeInvoices[drug.id] &&
                                            _vm.printDate(
                                              _vm.incomeInvoices[drug.id]
                                                .delivery_date,
                                              "DD.MM.YYYY"
                                            )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { attrs: { align: "right" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.incomeInvoices[drug.id] &&
                                            _vm.incomeInvoices[drug.id].id
                                        ) + "\n                "
                                      ),
                                      _vm.incomeInvoices[drug.id]
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-xs btn-info newWindowBtn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openInvoiceInModal(
                                                    _vm.incomeInvoices[drug.id]
                                                      .id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-eye",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ])
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c("tr", { staticClass: "total_tr" }, [
                              _c("td", { attrs: { colspan: "4" } }, [
                                _vm._v("Итого"),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.totalData.drugs))]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(_vm.totalData.sum))]),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                              _vm._v(" "),
                              _c("td"),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.loading &&
      _vm.inBackPacks &&
      _vm.inBackPacks.drugs &&
      Object.keys(_vm.inBackPacks.drugs).length
        ? _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("table", { staticClass: "table table-sm table-hover mt-0" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(
                      _vm.getSortedDrugs(_vm.inBackPacks.drugNames),
                      function (drug, i) {
                        return _vm._l(
                          _vm.inBackPacks.drugs[drug.id] || [],
                          function (back, runnerId, ii) {
                            return _c("tr", [
                              ii === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.inBackPacks.drugs[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(i + 1))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ii === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.inBackPacks.drugs[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(drug.id))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ii === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.inBackPacks.drugs[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(drug.title))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "(" +
                                    _vm._s(runnerId) +
                                    ") " +
                                    _vm._s(_vm.runnerNames[runnerId].name)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                _vm._l(back.orders, function (order) {
                                  return _c("p", { staticClass: "mb-0" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-xs btn-info newWindowBtn mr-1",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openOrderInModal(order)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-eye",
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(order) +
                                        "\n              "
                                    ),
                                  ])
                                }),
                                0
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(back.qty))]),
                              _vm._v(" "),
                              ii === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.inBackPacks.drugs[drug.id]
                                        ).length,
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getTotalQty(
                                              _vm.inBackPacks.drugs[drug.id],
                                              true
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.drugsOnHands && Object.keys(_vm.drugsOnHands).length
        ? _c("div", { staticClass: "card" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("table", { staticClass: "table table-sm mt-0 table-hover" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(
                      _vm.getSortedDrugs(Object.values(_vm.drugsNamesOnHangs)),
                      function (drug, ii) {
                        return _vm._l(
                          _vm.drugsOnHands[drug.id],
                          function (qty, runnerId, i) {
                            return _c("tr", [
                              i === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.drugsOnHands[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(ii + 1))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              i === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.drugsOnHands[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(drug.id))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              i === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.drugsOnHands[drug.id]
                                        ).length,
                                      },
                                    },
                                    [_vm._v(_vm._s(drug.title))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.runnerNames[runnerId])),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(qty))]),
                              _vm._v(" "),
                              i === 0
                                ? _c(
                                    "td",
                                    {
                                      attrs: {
                                        rowspan: Object.keys(
                                          _vm.drugsOnHands[drug.id]
                                        ).length,
                                      },
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getTotalQty(
                                              _vm.drugsOnHands[drug.id]
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          }
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_c("strong", [_vm._v("Препараты в рюкзаках")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявки")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Всего")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_c("strong", [_vm._v("Препараты на руках у курьеров")])]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Всего")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }